import { Form } from '@zillow/constellation';
import React from 'react';
import MilitaryInstallationSelector from '../MilitaryInstallationSelector/MilitaryInstallationSelector.js';

var MilitaryInstallationHomeSearch = function MilitaryInstallationHomeSearch() {
  var handleInstallationChange = function handleInstallationChange(value) {
    // hardcoding for now to this env where we have the new regions deployed
    // ideally this should be something like /homes/rid_${region}
    window.location.assign("https://www.tr1.test-automation.zillow.net/homes/" + value.toLowerCase().replaceAll(' ', '-'));
  };
  return /*#__PURE__*/React.createElement(Form, null, /*#__PURE__*/React.createElement(MilitaryInstallationSelector, {
    onChange: handleInstallationChange
  }));
};
var MilitaryInstallationHomeSearch$1 = MilitaryInstallationHomeSearch;

export { MilitaryInstallationHomeSearch$1 as default };
